import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import commonFormMeta from '@Shared/components/form/commonFormMeta';

export interface IReasonMeta{
  idReason: FormInputMeta,
  nameReason: FormInputMeta,

  schema: any,
}

const ReasonMeta: IReasonMeta= {} as IReasonMeta;

ReasonMeta.idReason = {
  name: 'idReason',
  type: 'text',
  label: 'ID Motif',
  placeholder: '',
  validation: yup.string().required(),
};

ReasonMeta.nameReason = {
  name: 'nameReason',
  type: 'text',
  label: 'Nom Motif',
  placeholder: '',
  validation: yup.string().required(),
};


const validationSchema: any = {};

for (let fieldname in ReasonMeta) {
  validationSchema[fieldname] = (ReasonMeta as any)[fieldname].validation;
}

ReasonMeta.schema = yup.object().shape(validationSchema);

export default ReasonMeta;

